import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DtpContentContainer, DtpNoContent, DtpButton } from 'dtp-react-components';
import { Table, Button } from '../../components';
import FiltroEnteGlosa from './FiltroEnteGlosa';
import { solicitarGlosas } from './actions';
import * as listUtils from '../../utils/listsSelect';
import {
  buscaDestinatarios,
  doGet,
  doDelete,
  trataMensagemSucesso,
  solicitarCompetenciaAberta,
} from '../../utils/requests';
import { manterApenasFiltro, pad } from '../../utils/helpers';
import ModalAlerta from '../requerimentos/ModalAlerta';
import { msgsGlosaDeDacaoManual } from '../../utils/constants';

class ConsultaGlosaDeDacao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idSolicitante: null,
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      filtrosPesquisaCnpj: {},
      showModalAlerta: false,
      existeCompetenciaInicial: true,
    };
  }

  componentDidMount() {
    solicitarCompetenciaAberta();
    // console.log(this.props.competenciaAberta);
    if (this.props.destinatarios.length === 0) {
      buscaDestinatarios(this.tratarErro);
    }
    this.realizaConsulta();

    this.buscaCompetenciaPagamentoAberta();
  }

  componentDidUpdate(prevProps) {
    manterApenasFiltro('filtroEnteFederativo');

    // Apenas repete consulta se parametro da url for alterado
    if (this.props.match.params.tipoConsulta !== prevProps.match.params.tipoConsulta) {
      this.preparaNovaConsulta();
    }
  }
  preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRegistrosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  realizaConsulta = (filtrosPesquisa) => {
    if (filtrosPesquisa) {
      this.setState({
        idSolicitante: filtrosPesquisa['destinatario-rpps'],
      });
      solicitarGlosas(filtrosPesquisa['destinatario-rpps'], `${this.props.competenciaAberta.ano}${pad(this.props.competenciaAberta.mes, 2)}`);
    }
  }

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: 'Não existe cnpj para o ente federativo escolhido.',
            noContentSecondaryMessage: 'Informe um ente federativo válido.',
          });
        } else {
          this.setState({
            showNoContent: true,
            noContentPrimaryMessage: `${data.mensagem}`,
            noContentSecondaryMessage: `${data.descricao}`,
          });
        }
      } else {
        this.setState({
          showNoContent: true,
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  newCadastroGlosaDeDacao = () => {
    this.props.history.push('/cadastros/glosaDeDacao/');
  }

  editCadastroGlosaDeDacao = (id) => {
    this.props.history.push(`/cadastros/glosaDeDacao/${id}`);
  }

  confirmDelete = () => {
    const { glosa } = { ...this.state };
    doDelete(
      'glosa-manual',
      glosa.idGlosa,
      () => {
        solicitarGlosas(glosa.idSolicitante, `${this.props.competenciaAberta.ano}${pad(this.props.competenciaAberta.mes, 2)}`);
        this.setState({
          showModalAlerta: !this.state.showModalAlerta,
        });
        trataMensagemSucesso(['Glosa excluída com sucesso.']);
      },
      'Não foi possível excluir a glosa.',
    );
  }

  deleteGlosaDeDacao = (paramGlosa) => {
    // console.log(paramGlosa);
    this.setState({
      alertas: [msgsGlosaDeDacaoManual.removerGlosadeDacao],
      showModalAlerta: !this.state.showModalAlerta,
      glosa: {
        ...paramGlosa,
      },
    });
  }

  buscaDadosCompetenciaPagamentoSuccess = (response) => {
    let objCompetencia = response.data.competencia;
    if (objCompetencia.length !== 7) {
      objCompetencia = `0${objCompetencia}`;
    }
    this.setState({
      competenciaAberta: objCompetencia,
    });
  };

  handleErrorDadosCompetenciaPagamento = () => {
    this.setState({
      existeCompetenciaInicial: false,
    });
  };

  buscaCompetenciaPagamentoAberta = () => {
    doGet(
      'fechamento-pagamentos/pagamento-aberto',
      this.buscaDadosCompetenciaPagamentoSuccess,
      this.handleErrorDadosCompetenciaPagamento,
    );
  }

  createActionColumn = (id, glosa) => {
    const mes = pad(glosa.competencia.split('/')[0], 2);
    const ano = glosa.competencia.split('/')[1];
    const competencia = `${ano}${mes}`;
    let competenciaAberta = '';

    if (this.state.competenciaAberta) {
      const mesAberto = pad(this.state.competenciaAberta.split('/')[0], 2);
      const anoAberto = this.state.competenciaAberta.split('/')[1];
      competenciaAberta = `${anoAberto}${mesAberto}`;
    }

    if (parseInt(competenciaAberta, 10) === parseInt(competencia, 10)) {
      return (
        <React.Fragment>
          <Button
            hint="Alterar glosa"
            icon="ico-doc-pencil"
            mini
            onClick={() => this.editCadastroGlosaDeDacao(id)}
          />
          <Button
            hint="Excluir glosa"
            icon="ico-trash-can"
            mini
            onClick={() => this.deleteGlosaDeDacao(glosa)}
          />
        </React.Fragment>
      );
    }

    return null;
  };

  alterarPagina = (pagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.paginaAtual = pagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  };

  addSolicitanteLabel = (id) => {
    let valor = '';
    if (id) {
      valor = listUtils.getObject(this.props.destinatarios, id).label;
    }
    return valor;
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  verificaSeCampoDesabilitado = () => {
    const { existeCompetenciaInicial } = { ...this.state };
    if (existeCompetenciaInicial === false) {
      return true;
    }
    return false;
  };

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmDelete}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    const options = {
      noDataText: 'Nenhuma glosa a ser exibida',
      hideSizePerPage: true,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
    };

    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };

    const colunasDefault = [
      { id: 'idSolicitante', label: 'Solicitante' },
      { id: 'competencia', label: 'Competência' },
      { id: 'valor', label: 'Valor' },
      { id: 'observacoes', label: 'Observações' },
      { id: 'acoes', label: 'Ações', dataFormat: this.createActionColumn },
    ];

    let glosas;
    if (Array.isArray(this.props.listaGlosas)) {
      glosas = this.props.listaGlosas.map(g => ({
        competencia: `${pad(g.mesPagamentoGlosa, 2)}/${g.anoPagamentoGlosa}`,
        idDestinatario: g.idDestinatario,
        idGlosa: g.idGlosa,
        idSolicitante: g.idSolicitante,
        observacoes: g.observacoes,
        tipoAplicacao: g.tipoAplicacao,
        tipoGlosa: g.tipoGlosa,
        valor: g.vlGlosa ? `R$ ${g.vlGlosa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 })}` : '',
        acoes: g.idGlosa,
      })).filter(g => g.idSolicitante === this.state.idSolicitante);
    } else {
      glosas = [];
    }

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <FiltroEnteGlosa
            handleSearchFilter={this.realizaConsulta}
            destinatarios={this.props.destinatarios}
            tipoConsulta={this.props.match.params.tipoConsulta}
            competencia={this.props.competenciaAberta}
            existeCompetenciaInicial={this.state.existeCompetenciaInicial}
          />
          <Table
            legend="Glosas de Dação"
            bordered
            fetchInfo={fetchInfo}
            data={glosas}
            options={options}
            listaTableHeader={colunasDefault}
            pagination
            remote
          />
          <DtpButton
            className="dtp-primary right"
            title="Adicionar Glosa de Dação"
            accessibilityName="Adicionar glosa de dação"
            onClick={() => this.newCadastroGlosaDeDacao()}
            disabled={!this.props.competenciaAberta}
          />
          {modalAlerta}
        </DtpContentContainer>
      )
    );
  }
}

ConsultaGlosaDeDacao.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      tipoConsulta: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
  destinatarios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  listaGlosas: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  competenciaAberta: PropTypes.string,
};

ConsultaGlosaDeDacao.defaultProps = {
  match: null,
  destinatarios: [],
  listaGlosas: [],
  competenciaAberta: null,
};

const mapStateToProps = state => ({
  destinatarios: state.base.destinatarios,
  listaGlosas: state.glosa.listaGlosas,
  competenciaAberta: state.base.competenciaAberta,
});

export default connect(mapStateToProps)(ConsultaGlosaDeDacao);



// WEBPACK FOOTER //
// ./src/pages/glosas/ConsultaGlosaDeDacao.jsx